export {
  AppstoreOutlined as AntIconSubmission,
  ArrowRightOutlined as AntIconView,
  CheckCircleOutlined as AntIconYes,
  DeleteOutlined as AntIconDelete,
  DownOutlined as AntIconArrowDown,
  EyeInvisibleOutlined as AntIconHidden,
  EyeOutlined as AntIconViewed,
  FallOutlined as AntIconCompanyBasic,
  FilterOutlined as AntIconPipeline,
  FolderOpenOutlined as AntIconStatusActive,
  FolderOutlined as AntIconStatusClosed,
  LoadingOutlined as AntIconLoading,
  MailOutlined as AntIconEmail,
  RiseOutlined as AntIconCompanyPremium,
  SolutionOutlined as AntIconCandidate,
  TeamOutlined as AntIconTeam,
  UsergroupAddOutlined as AntAntIconTeamAdd,
} from '@ant-design/icons';

// Import the wrapper function
import { createWrappedIcon } from './createWrappedIcon';

// Import original icon functions
import { IconActivity as OriginalIconActivity } from './Activity';
import { IconAlertTriangle as OriginalIconAlertTriangle } from './AlertTriangle';
import { IconAlignLeft as OriginalIconAlignLeft } from './AlignLeft';
import { IconArrowDown as OriginalIconArrowDown } from './ArrowDown';
import { IconArrowLeftCircle as OriginalIconArrowLeftCircle } from './ArrowLeftCircle';
import { IconArrowLeft as OriginalIconArrowLeft } from './ArrowLeft';
import { IconArrowRight as OriginalIconArrowRight } from './ArrowRight';
import { IconArrowUp as OriginalIconArrowUp } from './ArrowUp';
import { IconAtSign as OriginalIconAtSign } from './AtSign';
import { IconBarChart as OriginalIconBarChart } from './BarChart';
import { IconBell as OriginalIconBell } from './Bell';
import { IconBellSnooze as OriginalIconBellSnooze } from './BellSnooze';
import { IconBriefcase as OriginalIconBriefcase } from './Briefcase';
import { IconCalendar as OriginalIconCalendar } from './Calendar';
import { IconCamera as OriginalIconCamera } from './Camera';
import { IconCheckCircle as OriginalIconCheckCircle } from './CheckCircle';
import { IconCheck as OriginalIconCheck } from './Check';
import { IconChevronDown as OriginalIconChevronDown } from './ChevronDown';
import { IconChevronLeft as OriginalIconChevronLeft } from './ChevronLeft';
import { IconChevronRight as OriginalIconChevronRight } from './ChevronRight';
import { IconChevronsLeft as OriginalIconChevronsLeft } from './ChevronsLeft';
import { IconChevronsRight as OriginalIconChevronsRight } from './ChevronsRight';
import { IconChevronUpDown } from './ChevronUpDown'; // This one already has className support
import { IconChevronUp as OriginalIconChevronUp } from './ChevronUp';
import { IconCircleCheckFill as OriginalIconCircleCheckFill } from './CircleCheckFill';
import { IconCircleCheck as OriginalIconCircleCheck } from './CircleCheck';
import { IconCircleDashed as OriginalIconCircleDashed } from './CircleDashed';
import { IconCircleHalfFill as OriginalIconCircleHalfFill } from './CircleHalfFill';
import { IconClock as OriginalIconClock } from './Clock';
import { IconCog as OriginalIconCog } from './Cog';
import { IconCopy as OriginalIconCopy } from './Copy';
import { IconCornerDownLeft as OriginalIconCornerDownLeft } from './CornerDownLeft';
import { IconCornerDownRight as OriginalIconCornerDownRight } from './CornerDownRight';
import { IconDelete as OriginalIconDelete } from './Delete';
import { IconDocumentUpload as OriginalIconDocumentUpload } from './DocumentUpload';
import { IconDotFill as OriginalIconDotFill } from './DotFill';
import { IconDownloadCloud as OriginalIconDownloadCloud } from './DownloadCloud';
import { IconEdit3 as OriginalIconEdit3 } from './Edit3';
import { IconEdit as OriginalIconEdit } from './Edit';
import { IconExclamationCircle as OriginalIconExclamationCircle } from './ExclamationCircle';
import { IconExternalLink as OriginalIconExternalLink } from './ExternalLink';
import { IconEyeOff as OriginalIconEyeOff } from './EyeOff';
import { IconEye as OriginalIconEye } from './Eye';
import { IconFilePlus as OriginalIconFilePlus } from './FilePlus';
import { IconFileText as OriginalIconFileText } from './FileText';
import { IconFilterAlt as OriginalIconFilterAlt } from './FilterAlt';
import { IconFlame as OriginalIconFlame } from './Flame';
import { IconFolderGroup as OriginalIconFolderGroup } from './FolderGroup';
import { IconFolderInput as OriginalIconFolderInput } from './FolderInput';
import { IconFolderPlus as OriginalIconFolderPlus } from './FolderPlus';
import { IconFolder as OriginalIconFolder } from './Folder';
import { IconGitBranch as OriginalIconGitBranch } from './GitBranch';
import { IconGitCommit as OriginalIconGitCommit } from './GitCommit';
import { IconHand as OriginalIconHand } from './Hand';
import { IconHeartHandshake as OriginalIconHeartHandshake } from './HeartHandshake';
import { IconHome as OriginalIconHome } from './Home';
import { IconInboxFull as OriginalIconInboxFull } from './InboxFull';
import { IconInfo as OriginalIconInfo } from './Info';
import { IconLayers as OriginalIconLayers } from './Layers';
import { IconLightbulb1 as OriginalIconLightbulb1 } from './Lightbulb1';
import { IconLink2 as OriginalIconLink2 } from './Link2';
import { IconLink as OriginalIconLink } from './Link';
import { IconList as OriginalIconList } from './List';
import { IconLoader as OriginalIconLoader } from './Loader';
import { IconLock as OriginalIconLock } from './Lock';
import { IconLogOut as OriginalIconLogOut } from './LogOut';
import { IconMail as OriginalIconMail } from './Mail';
import { IconMapPin as OriginalIconMapPin } from './MapPin';
import { IconMessageCircle as OriginalIconMessageCircle } from './MessageCircle';
import { IconMessageSquare as OriginalIconMessageSquare } from './MessageSquare';
import { IconMinusCircle as OriginalIconMinusCircle } from './MinusCircle';
import { IconMinus as OriginalIconMinus } from './Minus';
import { IconMoreHorizontal as OriginalIconMoreHorizontal } from './MoreHorizontal';
import { IconMoreVertical as OriginalIconMoreVertical } from './MoreVertical';
import { IconOffice as OriginalIconOffice } from './Office';
import { IconPlusCircle as OriginalIconPlusCircle } from './PlusCircle';
import { IconPlus as OriginalIconPlus } from './Plus';
import { IconRefreshCcw as OriginalIconRefreshCcw } from './RefreshCcw';
import { IconRefreshCw as OriginalIconRefreshCw } from './RefreshCw';
import { IconSearch as OriginalIconSearch } from './Search';
import { IconShare2 as OriginalIconShare2 } from './Share2';
import { IconShare as OriginalIconShare } from './Share';
import { IconSortDown as OriginalIconSortDown } from './SortDown';
import { IconSortUp as OriginalIconSortUp } from './SortUp';
import { IconSparkles as OriginalIconSparkles } from './Sparkles';
import { IconStar as OriginalIconStar } from './Star';
import { IconTag as OriginalIconTag } from './Tag';
import { IconTarget as OriginalIconTarget } from './Target';
import { IconThumbsDown as OriginalIconThumbsDown } from './ThumbsDown';
import { IconThumbsUp as OriginalIconThumbsUp } from './ThumbsUp';
import { IconTrash2 as OriginalIconTrash2 } from './Trash2';
import { IconTrendingUp as OriginalIconTrendingUp } from './TrendingUp';
import { IconUploadCloud as OriginalIconUploadCloud } from './UploadCloud';
import { IconUserAlt as OriginalIconUserAlt } from './UserAlt';
import { IconUserCircleAlt as OriginalIconUserCircleAlt } from './UserCircleAlt';
import { IconUserCircle as OriginalIconUserCircle } from './UserCircle';
import { IconUserFilled as OriginalIconUserFilled } from './UserFilled';
import { IconUserGroupAlt as OriginalIconUserGroupAlt } from './UserGroupAlt';
import { IconUserMinus as OriginalIconUserMinus } from './UserMinus';
import { IconUserPlus as OriginalIconUserPlus } from './UserPlus';
import { IconUsersAlt as OriginalIconUsersAlt } from './UsersAlt';
import { IconUsersArrowsAlt as OriginalIconUsersArrowsAlt } from './UsersArrowsAlt';
import { IconUserSearch as OriginalIconUserSearch } from './UserSearch';
import { IconUserStar as OriginalIconUserStar } from './UserStar';
import { IconUsersTeam as OriginalIconUsersTeam } from './UsersTeam';
import { IconUser as OriginalIconUser } from './User';
import { IconXCircle as OriginalIconXCircle } from './XCircle';
import { IconX as OriginalIconX } from './X';
import { IconZap as OriginalIconZap } from './Zap';

// Export enhanced versions with className support (keeping the same names)
export const IconActivity = createWrappedIcon(OriginalIconActivity);
export const IconAlertTriangle = createWrappedIcon(OriginalIconAlertTriangle);
export const IconAlignLeft = createWrappedIcon(OriginalIconAlignLeft);
export const IconArrowDown = createWrappedIcon(OriginalIconArrowDown);
export const IconArrowLeftCircle = createWrappedIcon(
  OriginalIconArrowLeftCircle,
);
export const IconArrowLeft = createWrappedIcon(OriginalIconArrowLeft);
export const IconArrowRight = createWrappedIcon(OriginalIconArrowRight);
export const IconArrowUp = createWrappedIcon(OriginalIconArrowUp);
export const IconAtSign = createWrappedIcon(OriginalIconAtSign);
export const IconBarChart = createWrappedIcon(OriginalIconBarChart);
export const IconBell = createWrappedIcon(OriginalIconBell);
export const IconBellSnooze = createWrappedIcon(OriginalIconBellSnooze);
export const IconBriefcase = createWrappedIcon(OriginalIconBriefcase);
export const IconCalendar = createWrappedIcon(OriginalIconCalendar);
export const IconCamera = createWrappedIcon(OriginalIconCamera);
export const IconCheckCircle = createWrappedIcon(OriginalIconCheckCircle);
export const IconCheck = createWrappedIcon(OriginalIconCheck);
export const IconChevronDown = createWrappedIcon(OriginalIconChevronDown);
export const IconChevronLeft = createWrappedIcon(OriginalIconChevronLeft);
export const IconChevronRight = createWrappedIcon(OriginalIconChevronRight);
export const IconChevronsLeft = createWrappedIcon(OriginalIconChevronsLeft);
export const IconChevronsRight = createWrappedIcon(OriginalIconChevronsRight);
// IconChevronUpDown already has className support, so we export it as-is
export { IconChevronUpDown };
export const IconChevronUp = createWrappedIcon(OriginalIconChevronUp);
export const IconCircleCheckFill = createWrappedIcon(
  OriginalIconCircleCheckFill,
);
export const IconCircleCheck = createWrappedIcon(OriginalIconCircleCheck);
export const IconCircleDashed = createWrappedIcon(OriginalIconCircleDashed);
export const IconCircleHalfFill = createWrappedIcon(OriginalIconCircleHalfFill);
export const IconClock = createWrappedIcon(OriginalIconClock);
export const IconCog = createWrappedIcon(OriginalIconCog);
export const IconCopy = createWrappedIcon(OriginalIconCopy);
export const IconCornerDownLeft = createWrappedIcon(OriginalIconCornerDownLeft);
export const IconCornerDownRight = createWrappedIcon(
  OriginalIconCornerDownRight,
);
export const IconDelete = createWrappedIcon(OriginalIconDelete);
export const IconDocumentUpload = createWrappedIcon(OriginalIconDocumentUpload);
export const IconDotFill = createWrappedIcon(OriginalIconDotFill);
export const IconDownloadCloud = createWrappedIcon(OriginalIconDownloadCloud);
export const IconEdit3 = createWrappedIcon(OriginalIconEdit3);
export const IconEdit = createWrappedIcon(OriginalIconEdit);
export const IconExclamationCircle = createWrappedIcon(
  OriginalIconExclamationCircle,
);
export const IconExternalLink = createWrappedIcon(OriginalIconExternalLink);
export const IconEyeOff = createWrappedIcon(OriginalIconEyeOff);
export const IconEye = createWrappedIcon(OriginalIconEye);
export const IconFilePlus = createWrappedIcon(OriginalIconFilePlus);
export const IconFileText = createWrappedIcon(OriginalIconFileText);
export const IconFilterAlt = createWrappedIcon(OriginalIconFilterAlt);
export const IconFlame = createWrappedIcon(OriginalIconFlame);
export const IconFolderGroup = createWrappedIcon(OriginalIconFolderGroup);
export const IconFolderInput = createWrappedIcon(OriginalIconFolderInput);
export const IconFolderPlus = createWrappedIcon(OriginalIconFolderPlus);
export const IconFolder = createWrappedIcon(OriginalIconFolder);
export const IconGitBranch = createWrappedIcon(OriginalIconGitBranch);
export const IconGitCommit = createWrappedIcon(OriginalIconGitCommit);
export const IconHand = createWrappedIcon(OriginalIconHand);
export const IconHeartHandshake = createWrappedIcon(OriginalIconHeartHandshake);
export const IconHome = createWrappedIcon(OriginalIconHome);
export const IconInboxFull = createWrappedIcon(OriginalIconInboxFull);
export const IconInfo = createWrappedIcon(OriginalIconInfo);
export const IconLayers = createWrappedIcon(OriginalIconLayers);
export const IconLightbulb1 = createWrappedIcon(OriginalIconLightbulb1);
export const IconLink2 = createWrappedIcon(OriginalIconLink2);
export const IconLink = createWrappedIcon(OriginalIconLink);
export const IconList = createWrappedIcon(OriginalIconList);
export const IconLoader = createWrappedIcon(OriginalIconLoader);
export const IconLock = createWrappedIcon(OriginalIconLock);
export const IconLogOut = createWrappedIcon(OriginalIconLogOut);
export const IconMail = createWrappedIcon(OriginalIconMail);
export const IconMapPin = createWrappedIcon(OriginalIconMapPin);
export const IconMessageCircle = createWrappedIcon(OriginalIconMessageCircle);
export const IconMessageSquare = createWrappedIcon(OriginalIconMessageSquare);
export const IconMinusCircle = createWrappedIcon(OriginalIconMinusCircle);
export const IconMinus = createWrappedIcon(OriginalIconMinus);
export const IconMoreHorizontal = createWrappedIcon(OriginalIconMoreHorizontal);
export const IconMoreVertical = createWrappedIcon(OriginalIconMoreVertical);
export const IconOffice = createWrappedIcon(OriginalIconOffice);
export const IconPlusCircle = createWrappedIcon(OriginalIconPlusCircle);
export const IconPlus = createWrappedIcon(OriginalIconPlus);
export const IconRefreshCcw = createWrappedIcon(OriginalIconRefreshCcw);
export const IconRefreshCw = createWrappedIcon(OriginalIconRefreshCw);
export const IconSearch = createWrappedIcon(OriginalIconSearch);
export const IconShare2 = createWrappedIcon(OriginalIconShare2);
export const IconShare = createWrappedIcon(OriginalIconShare);
export const IconSortDown = createWrappedIcon(OriginalIconSortDown);
export const IconSortUp = createWrappedIcon(OriginalIconSortUp);
export const IconSparkles = createWrappedIcon(OriginalIconSparkles);
export const IconStar = createWrappedIcon(OriginalIconStar);
export const IconTag = createWrappedIcon(OriginalIconTag);
export const IconTarget = createWrappedIcon(OriginalIconTarget);
export const IconThumbsDown = createWrappedIcon(OriginalIconThumbsDown);
export const IconThumbsUp = createWrappedIcon(OriginalIconThumbsUp);
export const IconTrash2 = createWrappedIcon(OriginalIconTrash2);
export const IconTrendingUp = createWrappedIcon(OriginalIconTrendingUp);
export const IconUploadCloud = createWrappedIcon(OriginalIconUploadCloud);
export const IconUserAlt = createWrappedIcon(OriginalIconUserAlt);
export const IconUserCircleAlt = createWrappedIcon(OriginalIconUserCircleAlt);
export const IconUserCircle = createWrappedIcon(OriginalIconUserCircle);
export const IconUserFilled = createWrappedIcon(OriginalIconUserFilled);
export const IconUserGroupAlt = createWrappedIcon(OriginalIconUserGroupAlt);
export const IconUserMinus = createWrappedIcon(OriginalIconUserMinus);
export const IconUserPlus = createWrappedIcon(OriginalIconUserPlus);
export const IconUsersAlt = createWrappedIcon(OriginalIconUsersAlt);
export const IconUsersArrowsAlt = createWrappedIcon(OriginalIconUsersArrowsAlt);
export const IconUserSearch = createWrappedIcon(OriginalIconUserSearch);
export const IconUserStar = createWrappedIcon(OriginalIconUserStar);
export const IconUsersTeam = createWrappedIcon(OriginalIconUsersTeam);
export const IconUser = createWrappedIcon(OriginalIconUser);
export const IconXCircle = createWrappedIcon(OriginalIconXCircle);
export const IconX = createWrappedIcon(OriginalIconX);
export const IconZap = createWrappedIcon(OriginalIconZap);
